import { inject, Injectable } from '@angular/core';
import { LoggingService } from '../logging/logging.service';

@Injectable({ providedIn: 'root' })
export class ScorecardRefreshService {
  private readonly loggingService = inject(LoggingService);

  private refreshCallback?: () => void;

  setRefreshCallback(callback: () => void): void {
    this.refreshCallback = callback;
  }

  triggerRefresh(): void {
    if (this.refreshCallback) {
      this.refreshCallback();
    } else {
      this.loggingService.warn(
        'ScorecardRefreshService: No refresh callback registered',
        'ScorecardRefreshService'
      );
    }
  }
}
